module.exports = __webpack_public_path__ + "static/media/conviscope-logo.44109c78.jpg";